import React, { Component } from "react";
import {
  alert,
  DatePicker,
  DateRangePicker,
  format_date,
  GET,
  loading,
  Navbar,
  Pagination,
  POST,
  saveAs,
  Select,
  Status,
  toFixed,
  XLSX,
} from "../../components/CustomComponent.js";
import Dropdown from "react-bootstrap/Dropdown";

const GATEWAYS = [
    { key: "chillpay", name: "Chillpay", code: "CHL", settlement_time: "23:00:00 - 22:59:59", timezone: "UTC+7", last_settlement_at: "2026-03-14 04:00:40" },
    { key: "payso", name: "Payso", code: "PAY", settlement_time: "21:00:00 - 20:59:59", timezone: "UTC+7", last_settlement_at: "2026-03-14 03:00:48" },
    { key: "spark", name: "Spark", code: "SPK", settlement_time: "21:00:00 - 20:59:59", timezone: "UTC+7", last_settlement_at: "2026-03-14 01:31:22" },
    { key: "uniqpay", name: "Uniqpay", code: "UNQ", settlement_time: "21:00:00 - 20:59:59", timezone: "UTC+7", last_settlement_at: "2026-03-14 03:31:10" },
];

const STANDARD_RECONCILE_HEADERS = [
  "ref_no",
  "reference_id",
  "amount",
  "status",
  "currency",
  "transaction_date",
  "type",
];

export default class Reconciles extends Component {
  constructor(props) {
    super(props);
    const today = new Date();
    const defaultHistoryRange = this.GetDefaultHistoryRange(today);
    this.today = format_date(today, "yyyy-mm-dd", "en");

    this.state = {
      active_gateway: GATEWAYS[0].key,
      broker_uid: "",
      reconcile_type: "deposit",
      reconcile_date: this.today,
      history_start_date: defaultHistoryRange.start_date,
      history_end_date: defaultHistoryRange.end_date,
      history_rows: [],
      data_broker: [],
      import_file: null,
      import_file_name: "",
      detail_item: null,
      detail_transactions: [],
      detail_pagination: null,
      detail_status_filter: "",
      hover_detail_card: "",
      detail_page: 1,
      detail_page_size: 10,
      collapse_detail_fields: false,
      collapse_cost_fields: false,
      collapse_revenue_fields: false,
    };
    this.detailTableRefs = {
      detail: null,
      cost: null,
      revenue: null,
    };
    this.isSyncingDetailScroll = false;
  }

  GetDefaultHistoryRange = (baseDate = new Date()) => {
    const currentDate = new Date(baseDate);
    const currentDay = currentDate.getDate();
    const startDate =
      currentDay <= 14
        ? new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 15)
        : new Date(currentDate.getFullYear(), currentDate.getMonth(), 15);

    return {
      start_date: format_date(startDate, "yyyy-mm-dd", "en"),
      end_date: format_date(currentDate, "yyyy-mm-dd", "en"),
    };
  };

  componentDidMount = async () => {
    loading(false);
    await Promise.all([this.LoadBrokerOptions(), this.LoadHistory()]);
  };

  get selectedGateway() {
    return GATEWAYS.find((item) => item.key === this.state.active_gateway) || GATEWAYS[0];
  }

  GetStatus = (status) => {
    if (status === "matched") return Status("Matched", "success");
    if (status === "unmatched") return Status("Unmatched", "warning");
    if (status === "not_in_gateway") return Status("NotInGateway", "danger");
    if (status === "not_in_system") return Status("NotInSystem", "primary");
    return Status(status || "-", "dark");
  };

  GetHistoryStatus = (status) => {
    if (status === "processing") return Status("Processing", "warning");
    if (status === "done") return Status("Done", "success");
    return Status(status || "-", "dark");
  };

  SelectGateway = (gatewayKey) => {
    const defaultHistoryRange = this.GetDefaultHistoryRange();
    this.setState(
      {
        active_gateway: gatewayKey,
        broker_uid: "",
        reconcile_type: "deposit",
        reconcile_date: this.today,
        history_start_date: defaultHistoryRange.start_date,
        history_end_date: defaultHistoryRange.end_date,
        history_rows: [],
        import_file: null,
        import_file_name: "",
        detail_item: null,
        detail_transactions: [],
        detail_page: 1,
        collapse_detail_fields: false,
        collapse_cost_fields: false,
        collapse_revenue_fields: false,
      },
      async () => {
        await this.LoadHistory();
      }
    );
  };

  LoadBrokerOptions = async () => {
    const result = await GET("v1/admin/brokers/options", {
      page_size: 100000,
      page: 0,
      data_search: "",
    });

    this.setState({
      data_broker: result?.status
        ? (result.data || []).map((item) => ({
            value: item.uid,
            label: item.name_en || item.name_th || item.uid,
          }))
        : [],
    });
  };

  LoadHistory = async () => {
    const { active_gateway, history_start_date, history_end_date } = this.state;
    loading(true);
    const result = await GET("v1/admin/reconciles", {
        gateway: active_gateway,
        start_date: history_start_date ? format_date(history_start_date, "yyyy-mm-dd", "en") : "",
        end_date: history_end_date ? format_date(history_end_date, "yyyy-mm-dd", "en") : "",
    });
    this.setState({ history_rows: result?.status ? result.data || [] : [] });
    loading(false);
  };

  LoadDetail = async (item, page = 1, resetView = false) => {
    loading(true);
    const result = await GET(`v1/admin/reconciles/${item.uid}`, {
      page,
      page_size: this.state.detail_page_size,
    });
    this.setState((prev) => ({
      detail_item: result?.status ? result.data : item,
      detail_transactions: result?.status ? result.data?.detail_transactions || [] : [],
      detail_pagination: result?.status ? result.pagination || null : null,
      detail_status_filter: resetView ? "" : prev.detail_status_filter,
      hover_detail_card: "",
      detail_page: page,
      collapse_detail_fields: resetView ? false : prev.collapse_detail_fields,
      collapse_cost_fields: resetView ? false : prev.collapse_cost_fields,
      collapse_revenue_fields: resetView ? false : prev.collapse_revenue_fields,
    }));
    loading(false);
  };

  OpenDetail = async (item) => {
    await this.LoadDetail(item, 1, true);
  };

  CloseDetail = () => {
    this.setState({
      detail_item: null,
      detail_transactions: [],
      detail_pagination: null,
      detail_status_filter: "",
      hover_detail_card: "",
      detail_page: 1,
      collapse_detail_fields: false,
      collapse_cost_fields: false,
      collapse_revenue_fields: false,
    });
  };

  OpenFilePicker = () => {
    this.fileInput?.click();
  };

  HandleFileChange = (e) => {
    const file = e.target.files?.[0] || null;
    this.setState({ import_file: file, import_file_name: file?.name || "" });
  };

  NormalizeHeader = (value) => {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_");
  };

  ParseAmount = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    const normalized = value.toString().replace(/,/g, "").replace(/[^\d.-]/g, "");
    const amount = Number(normalized);
    return Number.isFinite(amount) ? amount : 0;
  };

  EscapeCsvValue = (value) => {
    const raw = value === null || value === undefined ? "" : value.toString();
    if (raw.includes(",") || raw.includes('"') || raw.includes("\n")) {
      return `"${raw.replace(/"/g, '""')}"`;
    }
    return raw;
  };

  BuildStandardCsv = (rows = []) => {
    const csvRows = [STANDARD_RECONCILE_HEADERS.join(",")];
    rows.forEach((row) => {
      csvRows.push(
        STANDARD_RECONCILE_HEADERS.map((header) => this.EscapeCsvValue(row[header] ?? "")).join(",")
      );
    });
    return csvRows.join("\n");
  };

  NormalizeStatus = (status) => {
    const normalized = (status || "").toString().trim().toLowerCase();
    if (["success", "successful", "completed", "complete", "paid"].includes(normalized)) return "success";
    if (["cancel", "cancelled", "failed", "fail", "error"].includes(normalized)) return "failed";
    if (["pending", "processing", "wait"].includes(normalized)) return "pending";
    return normalized;
  };

  FormatDateTimeFromDDMMYYYY = (value) => {
    const text = (value || "").toString().trim();
    const match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
    if (!match) return text;
    const [, dd, mm, yyyy, hh = "00", mi = "00", ss = "00"] = match;
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
  };

  FindHeaderRowIndex = (rows = [], requiredHeaders = []) => {
    return rows.findIndex((row) => {
      const normalized = row.map((cell) => this.NormalizeHeader(cell));
      return requiredHeaders.every((header) => normalized.includes(this.NormalizeHeader(header)));
    });
  };

  FindSheetByHeaders = (workbook, requiredHeaders = []) => {
    for (const sheetName of workbook.SheetNames) {
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        raw: false,
        defval: "",
      });
      const headerRowIndex = this.FindHeaderRowIndex(rows, requiredHeaders);
      if (headerRowIndex !== -1) {
        return { rows, headerRowIndex, sheetName };
      }
    }
    return null;
  };

  ExtractDateOnlyFromDateTime = (value) => {
    const text = (value || "").toString().trim();
    const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return "";
  };

  GetMajorityDateFromRows = (rows = [], fieldName = "transaction_date") => {
    const counter = rows.reduce((acc, item) => {
      const dateKey = this.ExtractDateOnlyFromDateTime(item[fieldName]);
      if (!dateKey) return acc;
      acc[dateKey] = (acc[dateKey] || 0) + 1;
      return acc;
    }, {});

    const entries = Object.entries(counter).sort((a, b) => b[1] - a[1]);
    if (!entries.length) {
      return { date: "", count: 0, total: 0 };
    }

    return {
      date: entries[0][0],
      count: entries[0][1],
      total: Object.values(counter).reduce((sum, value) => sum + value, 0),
    };
  };

  FormatChillpayWorkbook = async (file, reconcileType = "deposit") => {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: "array" });
    const sheetData = this.FindSheetByHeaders(workbook, [
      "Trans. ID",
      "Order No.",
      "Net Amount",
      "Payment Date",
      "Status",
      "Settled",
    ]);

    if (!sheetData) {
      throw new Error("Chillpay file format not supported");
    }

    const { rows, headerRowIndex, sheetName } = sheetData;
    const headers = rows[headerRowIndex].map((item) => this.NormalizeHeader(item));
    const dataRows = rows
      .slice(headerRowIndex + 1)
      .filter((row) => row.some((cell) => cell !== "") && `${row[0]}`.trim().toLowerCase() !== "total");

    const normalizedRows = dataRows.map((row) => {
      const item = {};
      headers.forEach((header, index) => {
        item[header] = row[index];
      });

      return {
        ref_no: item.order_no || "",
        reference_id: item.trans_id || "",
        amount: this.ParseAmount(item.net_amount || item.amount),
        status: this.NormalizeStatus(item.status),
        currency: (item.currency || "THB").toString().trim().toUpperCase(),
        transaction_date: this.FormatDateTimeFromDDMMYYYY(item.payment_date || item.transaction_date),
        type: reconcileType,
      };
    });

    const majorityPaymentDate = this.GetMajorityDateFromRows(normalizedRows, "transaction_date");

    return {
      rows: normalizedRows,
      file_content: this.BuildStandardCsv(normalizedRows),
      original_name: file.name,
      transformed_name: `${file.name.replace(/\.[^.]+$/, "")}-normalized.csv`,
      majority_payment_date: majorityPaymentDate.date,
      majority_payment_count: majorityPaymentDate.count,
      detected_sheet_name: sheetName,
    };
  };

  ReadFileContent = async (file, gatewayKey, reconcileType = "deposit") => {
    if (!file) return { rows: [], file_content: "", original_name: "", transformed_name: "" };

    if (gatewayKey === "chillpay") {
      return this.FormatChillpayWorkbook(file, reconcileType);
    }

    return {
      rows: [],
      file_content: await file.text(),
      original_name: file.name,
      transformed_name: file.name,
    };
  };

  ConfirmUpload = async () => {
    const { reconcile_date, import_file, broker_uid, reconcile_type } = this.state;
    const gateway = this.selectedGateway;

    if (!reconcile_date) {
      alert("", "warning", "Warning", "Please select Date");
      return;
    }
    if (!reconcile_type) {
      alert("", "warning", "Warning", "Please select Type");
      return;
    }
    if (!import_file) {
      alert("", "warning", "Warning", "Please import file from gateway");
      return;
    }

    const isConfirm = await alert(
      "",
      "info",
      "Confirm Upload",
      `Gateway: ${gateway.name} | Settlement: ${gateway.settlement_time} ${gateway.timezone} | Date: ${reconcile_date} | File: ${import_file.name}`,
      "Confirm",
      "Cancel"
    );

    if (!isConfirm) return;

    loading(true);
    let formattedFile;
    try {
        formattedFile = await this.ReadFileContent(import_file, gateway.key, reconcile_type);
    } catch (err) {
        loading(false);
        await alert("", "warning", "Warning", err?.message || "Unsupported file format");
        return;
    }

    if (
        formattedFile?.majority_payment_date &&
        formattedFile.majority_payment_date !== format_date(reconcile_date, "yyyy-mm-dd", "en")
    ) {
        loading(false);
        await alert(
            "",
            "warning",
            "Payment Date Mismatch",
            `Selected date: ${format_date(reconcile_date, "yyyy-mm-dd", "en")} | File Date: ${formattedFile.majority_payment_date} (${formattedFile.majority_payment_count || 0} rows)`
        );
        return;
    }
      
    const payload = {
        gateway: gateway.key,
        broker_uid,
        reconcile_type,
        settlement_time: gateway.settlement_time,
        reconcile_date: format_date(reconcile_date, "yyyy-mm-dd", "en"),
        file_name: formattedFile.transformed_name || import_file.name,
        file_size: import_file.size,
        file_content: formattedFile.file_content,
        currency: "THB",
    };
    
    const result = await POST("v1/admin/reconciles", payload);
    if (result?.status === true) {
      this.setState({
        import_file: null,
        import_file_name: "",
        detail_item: result.data,
        detail_transactions: result.data?.detail_transactions || [],
        detail_status_filter: "",
        hover_detail_card: "",
        detail_page: 1,
        collapse_detail_fields: false,
        collapse_cost_fields: false,
        collapse_revenue_fields: false,
      });
        await this.LoadHistory();
        await alert("", "success", "Success", "Reconcile uploaded successfully");
    } else {
        loading(false);
        await alert("", "warning", "Warning", result?.message || "Failed to upload reconcile");
    }
    loading(false);
  };

  RenderLabelValue = (label, value) => (
    <div className="d-flex mb-1">
      <div className="text-secondary text-12 wpx-140">{label}</div>
      <div className="text-12">{value ?? "-"}</div>
    </div>
  );

  SyncDetailTableScroll = (sourceKey) => {
    if (this.isSyncingDetailScroll) return;
    const sourceElement = this.detailTableRefs[sourceKey];
    if (!sourceElement) return;

    this.isSyncingDetailScroll = true;
    const nextScrollTop = sourceElement.scrollTop;
    Object.entries(this.detailTableRefs).forEach(([key, element]) => {
      if (key !== sourceKey && element && element.scrollTop !== nextScrollTop) {
        element.scrollTop = nextScrollTop;
      }
    });
    window.requestAnimationFrame(() => {
      this.isSyncingDetailScroll = false;
    });
  };

  FetchAllDetailTransactions = async (item) => {
    if (!item?.uid) return [];

    const result = await GET(`v1/admin/reconciles/${item.uid}`, {
      page: 1,
      page_size: 100000,
    });

    return result?.status ? result.data?.detail_transactions || [] : [];
  };

  BuildDetailExportRows = (transactions = [], detailReferenceLabel = "Reference ID") => {
    return transactions.map((tx, index) => ({
      No: index + 1,
      Status: tx.status || "-",
      "Date Time": tx.txn_datetime || "-",
      "Ref No": tx.ref_no || "-",
      [detailReferenceLabel]: tx.reference_id || "-",
      Type: tx.tx_type || "-",
      Currency: tx.currency || "-",
      Amount: Number(tx.amount_system || 0),
      "Gateway Amount": Number(tx.amount_gateway || 0),
      Variance: Number(tx.variance || 0),
      "Cost Fee Rate (%)": Number(tx.cost_gateway_fee_rate || 0),
      "Cost Fee Amount": Number(tx.cost_gateway_fee || 0),
      "Cost VAT": Number(tx.cost_gateway_vat || 0),
      "Cost Total": Number(tx.cost_gateway_total || 0),
      "Revenue Fee Rate (%)": Number(tx.revenue_fee_rate || 0),
      "Revenue Fee Amount": Number(tx.revenue_fee_amount || 0),
      "Revenue VAT": Number(tx.revenue_vat || 0),
      "Revenue Total": Number(tx.revenue_total || 0),
      "Gross Profit": Number(tx.revenue_gross_profit || 0),
    }));
  };

  ExportDetailExcel = async () => {
    const { detail_item } = this.state;
    if (!detail_item?.uid) {
      alert("", "warning", "Warning", "No reconcile detail selected");
      return;
    }

    loading(true);
    try {
      const allTransactions = await this.FetchAllDetailTransactions(detail_item);

      if (!allTransactions.length) {
        loading(false);
        await alert("", "warning", "Warning", "No transaction details to export");
        return;
      }

      const detailReferenceLabel =
        (detail_item?.reconcile_type || this.state.reconcile_type || "").toString().toLowerCase() === "deposit"
          ? "Ref QR"
          : "Ref Payout";
      const jsonData = this.BuildDetailExportRows(allTransactions, detailReferenceLabel);
      const worksheet = XLSX.utils.json_to_sheet(jsonData);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction Detail");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });
      saveAs(file, `reconcile-detail-${detail_item.reconcile_date || "all"}.xlsx`);
    } catch (err) {
      await alert("", "warning", "Warning", err?.message || "Failed to export excel");
    }
    loading(false);
  };

  render() {
    const {
      active_gateway,
      broker_uid,
      reconcile_type,
      reconcile_date,
      history_start_date,
      history_end_date,
      history_rows,
      data_broker,
      import_file_name,
      detail_item,
      detail_transactions,
      detail_pagination,
      detail_status_filter,
      hover_detail_card,
      detail_page,
      detail_page_size,
      collapse_detail_fields,
      collapse_cost_fields,
      collapse_revenue_fields,
    } = this.state;
    const isDetailCollapsed = !!collapse_detail_fields;
    const isCostCollapsed = !!collapse_cost_fields;
    const isRevenueCollapsed = !!collapse_revenue_fields;

    const gateway = this.selectedGateway;
    const detailReferenceLabel =
      (detail_item?.reconcile_type || reconcile_type || "").toString().toLowerCase() === "deposit"
        ? "Ref QR"
        : "Ref Payout";
    const filteredDetailTransactions = detail_status_filter
      ? detail_transactions.filter(
          (tx) => ((tx.status || "").toString().trim().toLowerCase() || "default") === detail_status_filter
        )
      : detail_transactions;
    const paginatedDetailTransactions = filteredDetailTransactions;
    const detailPageCount = detail_pagination?.count
      ? Math.max(1, Math.ceil(detail_pagination.count / detail_page_size))
      : 1;
    const statusCardConfig = {
      matched: { label: "Matched", bg: "#eaf8ef", border: "#b9e7c9", text: "#1f7a3d", description: "Transactions found in both System and Gateway with matching amounts and status." },
      unmatched: { label: "Unmatched", bg: "#fff7e8", border: "#ffd99b", text: "#a86400", description: "Transactions found in both System and Gateway but with different values or status." },
      not_in_gateway: { label: "NotInGateway", bg: "#fff0f0", border: "#f3b7b7", text: "#b42318", description: "Transactions that exist in System but do not appear in the uploaded Gateway file." },
      not_in_system: { label: "NotInSystem", bg: "#eef4ff", border: "#c9dafc", text: "#1d4ed8", description: "Transactions that appear in the uploaded Gateway file but do not exist in System." },
      default: { label: "Other", bg: "#f4f5f7", border: "#d5d9e0", text: "#4b5563" },
    };
    const detailStatusSummary = {
      matched: {
        key: "matched",
        count: Number(detail_item?.matched_records || 0),
        amount_system: Number(detail_item?.matched_amount || 0),
        amount_gateway: Number(detail_item?.matched_amount || 0),
      },
      unmatched: {
        key: "unmatched",
        count: Number(detail_item?.unmatched_records || 0),
        amount_system: Number(detail_item?.unmatched_amount || 0),
        amount_gateway: Number(detail_item?.unmatched_amount || 0),
      },
      not_in_gateway: {
        key: "not_in_gateway",
        count: Number(detail_item?.not_in_gateway_records || 0),
        amount_system: Number(detail_item?.not_in_gateway_amount || 0),
        amount_gateway: 0,
      },
      not_in_system: {
        key: "not_in_system",
        count: Number(detail_item?.not_in_system_records || 0),
        amount_system: 0,
        amount_gateway: Number(detail_item?.not_in_system_amount || 0),
      },
    };
    const statusCardOrder = [
      "matched",
      "unmatched",
      "not_in_gateway",
      "not_in_system",
    ];
    const detailStatusCards = statusCardOrder.map((statusKey) => ({
      key: statusKey,
      count: detailStatusSummary[statusKey]?.count || 0,
      amount_system: detailStatusSummary[statusKey]?.amount_system || 0,
      amount_gateway: detailStatusSummary[statusKey]?.amount_gateway || 0,
    }));
    const detailTotalSystemAmount =
      Number(detail_item?.matched_amount || 0) +
      Number(detail_item?.unmatched_amount || 0) +
      Number(detail_item?.not_in_gateway_amount || 0);
    const detailTotalGatewayAmount =
      Number(detail_item?.matched_amount || 0) +
      Number(detail_item?.unmatched_amount || 0) +
      Number(detail_item?.not_in_system_amount || 0);
    const detailTotalVariance = detail_transactions.reduce((sum, tx) => sum + (Number(tx.variance) || 0), 0);
    const detailSystemCount =
      Number(detail_item?.matched_records || 0) +
      Number(detail_item?.unmatched_records || 0) +
      Number(detail_item?.not_in_gateway_records || 0);
    const detailGatewayCount =
      Number(detail_item?.matched_records || 0) +
      Number(detail_item?.unmatched_records || 0) +
      Number(detail_item?.not_in_system_records || 0);
    const summaryCardBaseStyle = {
      flex: "1 1 220px",
      minWidth: 220,
      minHeight: 82,
    };
    const activeSummaryCardStyle = {
      boxShadow: "0 0 0 2px rgba(17, 24, 39, 0.12)",
      transform: "translateY(-1px)",
    };
    const workspacePanelHeight = 560;
    const detailTableHeaderHeight = 45;
    const detailTableRowHeight = 32;
    const detailTableHeight = detailTableHeaderHeight + detailTableRowHeight * detail_page_size;
    const syncedTableRowStyle = {
      height: detailTableRowHeight,
      verticalAlign: "middle",
    };
    const buildPanelStyle = (collapsed, expandedWidth, collapsedWidth, borderColor, background) => ({
      flex: `0 0 ${collapsed ? collapsedWidth : expandedWidth}px`,
      minWidth: collapsed ? collapsedWidth : expandedWidth,
      borderColor,
      background,
      transition: "all 0.28s cubic-bezier(0.22, 1, 0.36, 1)",
      boxShadow: collapsed ? "inset 0 0 0 1px rgba(255,255,255,0.35)" : "0 8px 18px rgba(15, 23, 42, 0.04)",
    });
    const detailPanelStyle = buildPanelStyle(isDetailCollapsed, 1110, 340, "#d8e4ff", "#f9fbff");
    const keepVisibleCellStyle = (expandedWidth, _collapsedWidth, align = "center") => ({
      width: expandedWidth,
      minWidth: expandedWidth,
      maxWidth: expandedWidth,
      textAlign: align,
      transition: "all 0.22s ease",
    });
    const collapseCellStyle = (width) =>
      ({
        width,
        minWidth: width,
        maxWidth: width,
        opacity: 1,
        transform: "translateX(0)",
        transition: "all 0.22s ease",
      });
    const costPanelStyle = buildPanelStyle(isCostCollapsed, 470, 340, "#ffe0c2", "#fffaf5");
    const revenuePanelStyle = buildPanelStyle(isRevenueCollapsed, 590, 340, "#cbeed9", "#f4fff8");
    const getTableViewportStyle = (collapsed) => ({
      height: detailTableHeight,
      overflow: collapsed ? "auto" : "hidden",
    });
    const keepVisibleCostCellStyle = (expandedWidth, _collapsedWidth) => ({
      width: expandedWidth,
      minWidth: expandedWidth,
      maxWidth: expandedWidth,
      transition: "all 0.22s ease",
    });
    const keepVisibleRevenueCellStyle = (expandedWidth, _collapsedWidth) => ({
      width: expandedWidth,
      minWidth: expandedWidth,
      maxWidth: expandedWidth,
      transition: "all 0.22s ease",
    });
    const collapseCostCellStyle = (width) =>
      ({
        width,
        minWidth: width,
        maxWidth: width,
        opacity: 1,
        transform: "translateX(0)",
        transition: "all 0.22s ease",
      });
    const collapseRevenueCellStyle = (width) =>
      ({
        width,
        minWidth: width,
        maxWidth: width,
        opacity: 1,
        transform: "translateX(0)",
        transition: "all 0.22s ease",
      });
    const getToggleButtonStyle = (collapsed, tone) => ({
      border: `1px solid ${collapsed ? tone.border : tone.softBorder}`,
      background: collapsed ? tone.bg : "#ffffff",
      color: tone.text,
      borderRadius: 999,
      padding: "4px 10px",
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.2,
      transition: "all 0.22s ease",
      boxShadow: collapsed ? `0 4px 10px ${tone.shadow}` : "none",
    });
    const panelTone = {
      detail: { text: "#2155c9", bg: "#edf4ff", border: "#bfd4ff", softBorder: "#d8e4ff", shadow: "rgba(33, 85, 201, 0.16)" },
      cost: { text: "#b45309", bg: "#fff1df", border: "#ffd3aa", softBorder: "#ffe0c2", shadow: "rgba(180, 83, 9, 0.14)" },
      revenue: { text: "#15803d", bg: "#e9fff0", border: "#bae6c8", softBorder: "#cbeed9", shadow: "rgba(21, 128, 61, 0.14)" },
    };
    const totalTransactionsDescription = "All transactions included in this reconcile run across System and Gateway for the selected file.";

    return (
        <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
            <Navbar />
            <div className="body p-3 mt-3">
                <div className={`reconcile-detail-overlay ${hover_detail_card ? "show" : ""}`}></div>
                <div className="ar-hero mb-4">
                    <div className="ar-hero-head">
                        <div>
                            <div className="ar-eyebrow mb-1">Reports</div>
                            <div className="ar-title">Payment Reconcile</div>
                            <div className="ar-subtitle">Select gateway from the top bar, then view history or upload file</div>
                        </div>
                    </div>
                    <div className="ar-toolbar mt-3">
                    <div className="d-flex overflow-auto pb-1">
                        {GATEWAYS.map((item) => (
                            <button
                                key={`top-${item.key}`}
                                className={`btn me-2 text-nowrap ${active_gateway === item.key ? "" : "btn-light"}`}
                                style={
                                    active_gateway === item.key
                                        ? {
                                            background: "linear-gradient(135deg, #fff3cf 0%, #f1c96b 100%)",
                                            border: "1px solid #d9b04f",
                                            color: "#6f4b00",
                                            boxShadow: "0 8px 18px rgba(217, 176, 79, 0.24)",
                                          }
                                        : undefined
                                }
                                onClick={() => this.SelectGateway(item.key)}
                            >
                                <span className="fw-bold">{item.name}</span>
                                <span className={`ms-2 text-12 ${active_gateway === item.key ? "" : "text-secondary"}`} style={active_gateway === item.key ? { color: "#8a6508" } : undefined}>
                                    {item.settlement_time}
                                </span>
                            </button>
                        ))}
                    </div>
                    </div>
                </div>

                <div className="row g-3">
                    <div className="col-12">
                        <div className="ar-table-card p-3 mb-3">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div>
                                    <h5 className="fw-bold mb-1" style={{ color: "blue" }}>
                                        {gateway.name} Reconcile Workspace
                                    </h5>
                                    <div className="text-secondary text-12">
                                        Settlement at {gateway.settlement_time} {gateway.timezone}
                                    </div>
                                </div>
                                <span className="badge bg-secondary">{gateway.code}</span>
                            </div>
                        </div>

                        <div className="row g-3">
                            {/* Upload Reconcile File */}
                            <div className="col-12 col-lg-3">
                                <div className="ar-table-card p-3 h-100 d-flex flex-column" style={{ height: `${workspacePanelHeight}px` }}>
                                    <h5 className="fw-bold mb-2">Upload Reconcile File</h5>
                                    <div className="text-secondary text-12 mb-2">Step 1: Select date</div>
                                    <DatePicker className="form-control mb-3" onChange={(e) => this.setState({ reconcile_date: e })} value={reconcile_date} max={this.today} />
                                    <Select
                                        className="form-control mb-3"
                                        placeholder="Type..."
                                        options={[
                                            { value: "deposit", label: "Deposit" },
                                            { value: "withdrawals", label: "Withdrawal" },
                                        ]}
                                        value={reconcile_type}
                                        onChange={(v) => this.setState({ reconcile_type: v })}
                                    />
                                    <Select className="form-control mb-3" placeholder="Broker..." options={data_broker} onChange={(e) => this.setState({ broker_uid: e })} value={broker_uid} />
                                    <input
                                        ref={(el) => {
                                            this.fileInput = el;
                                        }}
                                        type="file"
                                        className="d-none"
                                        onChange={this.HandleFileChange}
                                    />

                                    <div className="rounded-3 px-3 py-2 mb-3 text-center" style={{ border: "1px dashed #b8bec5", background: "#f8f9fb" }}>
                                        <div className="text-secondary text-12 mb-2">Step 2: Import file</div>
                                        <button className="btn border-none px-3 py-0" onClick={this.OpenFilePicker}>
                                            <span className="icon text-30 text-secondary">{"\uf0c2"}</span>
                                        </button>
                                        <div className="text-secondary text-12 mb-1">
                                            {import_file_name ? (
                                                <span className="d-inline-block w-100 text-start" title={import_file_name}>
                                                    <span className="d-inline-block align-middle w-100" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                        {import_file_name}
                                                    </span>
                                                </span>
                                            ) : (
                                                "No file selected"
                                            )}
                                        </div>
                                        {!!import_file_name && (
                                            <button className="btn btn-sm btn-light border mt-1" onClick={() => this.setState({ import_file: null, import_file_name: "" })}>
                                                Clear File
                                            </button>
                                        )}
                                    </div>
                                    <button className="ar-btn-gold w-100 justify-content-center reconciles.update" disabled={!import_file_name} onClick={this.ConfirmUpload}>
                                        Confirm Upload
                                    </button>

                                    <div className="text-secondary text-12 text-center mt-2">
                                        Target Gateway: {gateway.name} ({gateway.code})
                                    </div>
                                </div>
                            </div>

                            {/* View Reconcile Data */}
                            <div className="col-12 col-lg-9">
                                <div className="ar-table-card p-3 h-100 d-flex flex-column" style={{ height: `${workspacePanelHeight}px` }}>
                                    <h5 className="fw-bold mb-2">View Reconcile Data</h5>
                                    <div className="d-flex flex-wrap align-items-center mb-2">
                                        <div className="wpx-230 me-2 mb-2">
                                            <DateRangePicker
                                                className="form-control"
                                                onChange={(e) => {
                                                    this.setState({
                                                        history_start_date: e.start_date,
                                                        history_end_date: e.end_date,
                                                    });
                                                }}
                                                value={{
                                                    start_date: history_start_date,
                                                    end_date: history_end_date,
                                                }}
                                                max={this.today}
                                            />
                                        </div>
                                        <button className="ar-btn-gold px-3 me-2 mb-2" onClick={this.LoadHistory}>
                                            Search
                                        </button>
                                    </div>

                                    <div className="table-responsive flex-grow-1" style={{ overflowY: "auto", minHeight: 0 }}>
                                        <table className="table table-hover ar-table pu-table pu-table-compact mb-0">
                                            <thead>
                                                <tr>
                                                    <td className="text-nowrap">Date</td>
                                                    <td className="text-nowrap">Gateway</td>
                                                    <td className="text-nowrap">Type</td>
                                                    <td className="text-end">Matched</td>
                                                    <td className="text-end">Unmatched</td>
                                                    <td className="text-end">NotInGateway</td>
                                                    <td className="text-end">NotInSystem</td>
                                                    <td className="text-end">Variance</td>
                                                    <td className="text-center">Status</td>
                                                    <td className="text-center td-actions">Actions</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {history_rows.map((item, index) => (
                                                    <tr key={`history-${index}`}>
                                                        <td className="text-nowrap">{item.reconcile_date}</td>
                                                        <td className="text-nowrap">{item.gateway}</td>
                                                        <td className="text-nowrap">{item.reconcile_type}</td>
                                                        <td className="text-end">{item.matched_records}</td>
                                                        <td className="text-end">{item.unmatched_records}</td>
                                                        <td className="text-end">{item.not_in_gateway_records || 0}</td>
                                                        <td className="text-end">{item.not_in_system_records || 0}</td>
                                                        <td className={`text-end ${item.variance_amount > 0 ? "text-danger" : ""}`}>{toFixed(item.variance_amount, 2)}</td>
                                                        <td className="text-center">
                                                            <div className="d-flex justify-content-center w-100">{this.GetHistoryStatus(item.status)}</div>
                                                        </td>
                                                        <td data-label="Actions" className="text-center td-actions">
                                                            <Dropdown align="end">
                                                                <Dropdown.Toggle className="pu-action-toggle" id={`reconciles-actions-${index}`}>Action</Dropdown.Toggle>
                                                                <Dropdown.Menu className="pu-action-menu pu-menu-fixed" popperConfig={{ strategy: "fixed" }}>
                                                                    <Dropdown.Item className="pu-action-item" onClick={() => this.OpenDetail(item)}>
                                                                        <span className="icon">{"\uf06e"}</span>Detail
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {!history_rows.length && (
                                                    <tr>
                                                        <td colSpan="10" className="text-center text-secondary py-4">
                                                            No reconcile history
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {!!detail_item && (
                            <div className="ar-table-card p-3 mt-3">
                                <div className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                                    <h5 className="fw-bold mb-0">Transaction Detail Workspace</h5>
                                    <div className="d-flex align-items-center gap-2 mt-2 mt-sm-0">
                                        <button className="btn btn-sm btn-success" onClick={this.ExportDetailExcel}>
                                            <span className="icon me-1">{"\uf1c3"}</span>
                                            Download Excel
                                        </button>
                                        <button className="btn btn-sm btn-outline-dark" onClick={this.CloseDetail}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                                <div className="text-12 text-secondary mb-2">
                                    Gateway: <b>{gateway.name}</b> | Reconcile Date: <b>{detail_item.reconcile_date}</b> | Gateway Settlement:{" "}
                                    <b>
                                        {gateway.settlement_time} {gateway.timezone}
                                    </b>
                                </div>

                                {!!detailStatusCards.length && (
                                    <div className="mb-3">
                                        <div className="d-flex flex-wrap" style={{ gap: 12 }}>
                                            <div
                                                className={`rounded-3 px-3 py-2 d-flex flex-column justify-content-between reconcile-detail-card ${hover_detail_card === "total_transactions" ? "is-active" : ""}`}
                                                role="button"
                                                style={{
                                                    ...summaryCardBaseStyle,
                                                    background: "#fff7db",
                                                    border: "1px solid #f1d27a",
                                                    lineHeight: 1.25,
                                                    cursor: "pointer",
                                                    ...(detail_status_filter === "" ? activeSummaryCardStyle : {}),
                                                }}
                                                onClick={() => this.setState({ detail_status_filter: "", detail_page: 1 })}
                                                onMouseEnter={() => this.setState({ hover_detail_card: "total_transactions" })}
                                                onMouseLeave={() => this.setState({ hover_detail_card: "" })}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="fw-bold text-13" style={{ color: "#9a6700" }}>
                                                        Total Transactions
                                                    </div>
                                                    <div className="fw-bold" style={{ color: "#7a5200" }}>
                                                        {Number(detail_item?.total_records || 0)}
                                                    </div>
                                                </div>
                                                <div className="text-12 mt-1" style={{ color: "#9a6700" }}>
                                                    System: {toFixed(detailTotalSystemAmount, 2)}
                                                </div>
                                                <div className="text-12" style={{ color: "#9a6700" }}>
                                                    Gateway: {toFixed(detailTotalGatewayAmount, 2)}
                                                </div>
                                                <div className="reconcile-detail-tooltip">
                                                    <div className="fw-semibold mb-1" style={{ fontSize: 13, color: "#9a6700" }}>
                                                        Total Transactions
                                                    </div>
                                                    <div style={{ fontSize: 12, lineHeight: 1.5 }}>{totalTransactionsDescription}</div>
                                                </div>
                                            </div>
                                            {detailStatusCards.map((item) => {
                                                const config = statusCardConfig[item.key] || statusCardConfig.default;
                                                return (
                                                    <div
                                                        key={`status-summary-${item.key}`}
                                                        className={`rounded-3 px-3 py-2 d-flex flex-column justify-content-between reconcile-detail-card ${hover_detail_card === item.key ? "is-active" : ""}`}
                                                        role="button"
                                                        style={{
                                                            ...summaryCardBaseStyle,
                                                            background: config.bg,
                                                            border: `1px solid ${config.border}`,
                                                            lineHeight: 1.25,
                                                            cursor: "pointer",
                                                            ...(detail_status_filter === item.key ? activeSummaryCardStyle : {}),
                                                        }}
                                                        onClick={() => this.setState({ detail_status_filter: item.key, detail_page: 1 })}
                                                        onMouseEnter={() => this.setState({ hover_detail_card: item.key })}
                                                        onMouseLeave={() => this.setState({ hover_detail_card: "" })}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="fw-bold text-13" style={{ color: config.text }}>
                                                                {config.label}
                                                            </div>
                                                            <div className="fw-bold" style={{ color: config.text }}>
                                                                {item.count}
                                                            </div>
                                                        </div>
                                                        <div className="text-12 text-secondary mt-1">
                                                            System: {toFixed(item.amount_system, 2)}
                                                        </div>
                                                        <div className="text-12 text-secondary">
                                                            Gateway: {toFixed(item.amount_gateway, 2)}
                                                        </div>
                                                        <div className="reconcile-detail-tooltip">
                                                            <div className="fw-semibold mb-1" style={{ fontSize: 13, color: config.text }}>
                                                                {config.label}
                                                            </div>
                                                            <div style={{ fontSize: 12, lineHeight: 1.5 }}>{config.description}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                )}

                                <div className="w-100 overflow-auto mb-3">
                                    <div className="d-flex flex-nowrap" style={{ gap: 12 }}>
                                        <div className="rounded-3 border p-2 d-flex flex-column" style={detailPanelStyle}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                                                <div>
                                                    <div className="fw-bold">Detail</div>
                                                    <div className="text-12 text-secondary">{isDetailCollapsed ? "Compact view: key fields only" : "Full view: all detail fields"}</div>
                                                </div>
                                                <button
                                                    className="btn btn-sm"
                                                    style={getToggleButtonStyle(isDetailCollapsed, panelTone.detail)}
                                                    onClick={() => this.setState({ collapse_detail_fields: !isDetailCollapsed })}
                                                >
                                                    {isDetailCollapsed ? "Show All Fields" : "Hide Extra Fields"}
                                                </button>
                                            </div>
                                            <div
                                                ref={(el) => {
                                                    this.detailTableRefs.detail = el;
                                                }}
                                                className="table-responsive flex-grow-1"
                                                style={getTableViewportStyle(isDetailCollapsed)}
                                                onScroll={() => this.SyncDetailTableScroll("detail")}
                                            >
                                                <table className="table table-sm table-hover mb-0" style={{ minWidth: "100%", width: "max-content" }}>
                                                    <thead>
                                                        <tr>
                                                            <td className="text-nowrap text-center" style={collapseCellStyle(50)}>
                                                                No
                                                            </td>
                                                            <td className="text-nowrap text-center" style={keepVisibleCellStyle(85, 92)}>
                                                                Status
                                                            </td>
                                                            <td className="text-nowrap text-center" style={collapseCellStyle(145)}>
                                                                Date Time
                                                            </td>
                                                            <td className="text-nowrap text-center" style={keepVisibleCellStyle(150, 132)}>
                                                                Ref No
                                                            </td>
                                                            <td className="text-nowrap text-center px-4" style={collapseCellStyle(150)}>
                                                                {detailReferenceLabel}
                                                            </td>
                                                            <td className="text-nowrap text-center" style={collapseCellStyle(80)}>
                                                                Type
                                                            </td>
                                                            <td className="text-nowrap text-center" style={collapseCellStyle(78)}>
                                                                Currency
                                                            </td>
                                                            <td className="text-nowrap text-end" style={keepVisibleCellStyle(80, 92, "right")}>
                                                                Amount
                                                            </td>
                                                            <td className="text-nowrap text-end" style={collapseCellStyle(125)}>
                                                                Gateway Amount
                                                            </td>
                                                            <td className="text-nowrap text-end" style={keepVisibleCellStyle(80, 92, "right")}>
                                                                Variance
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paginatedDetailTransactions.map((tx, idx) => (
                                                            <tr key={`detail-row-${idx}`} style={syncedTableRowStyle}>
                                                                <td className="text-center">{(detail_page - 1) * detail_page_size + idx + 1}</td>
                                                                <td className="text-center" style={keepVisibleCellStyle(80, 92)}>
                                                                    <div className="d-flex justify-content-center">{this.GetStatus(tx.status)}</div>
                                                                </td>
                                                                <td className="text-nowrap text-center text-12" style={collapseCellStyle(145)}>
                                                                    {tx.txn_datetime || "-"}
                                                                </td>
                                                                <td className="text-nowrap text-center text-12" style={keepVisibleCellStyle(150, 132)}>
                                                                    {tx.ref_no}
                                                                </td>
                                                                <td className="text-nowrap text-center text-12" style={collapseCellStyle(150)}>
                                                                    {tx.reference_id}
                                                                </td>
                                                                <td className="text-nowrap text-center text-12" style={collapseCellStyle(80)}>
                                                                    {tx.tx_type || "-"}
                                                                </td>
                                                                <td className="text-nowrap text-center text-12" style={collapseCellStyle(78)}>
                                                                    {tx.currency || "-"}
                                                                </td>
                                                                <td className="text-end text-12" style={keepVisibleCellStyle(80, 92, "right")}>
                                                                    {toFixed(tx.amount_system, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={collapseCellStyle(125)}>
                                                                    {toFixed(tx.amount_gateway, 2)}
                                                                </td>
                                                                <td className={`text-end text-12 ${tx.variance !== 0 ? "text-danger fw-bold" : ""}`} style={keepVisibleCellStyle(80, 92, "right")}>
                                                                    {toFixed(tx.variance, 2)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {!filteredDetailTransactions.length && (
                                                            <tr style={syncedTableRowStyle}>
                                                                <td colSpan="10" className="text-center text-secondary py-3">
                                                                    {detail_status_filter ? "No transaction details for selected status" : "No transaction details"}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="rounded-3 border p-2 d-flex flex-column" style={costPanelStyle}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                                                <div>
                                                    <div className="fw-bold">Cost - Gateway</div>
                                                    <div className="text-12 text-secondary">{isCostCollapsed ? "Compact view: totals first" : "Full view: fee breakdown"}</div>
                                                </div>
                                                <button
                                                    className="btn btn-sm"
                                                    style={getToggleButtonStyle(isCostCollapsed, panelTone.cost)}
                                                    onClick={() => this.setState({ collapse_cost_fields: !isCostCollapsed })}
                                                >
                                                    {isCostCollapsed ? "Show All Fields" : "Hide Extra Fields"}
                                                </button>
                                            </div>
                                            <div
                                                ref={(el) => {
                                                    this.detailTableRefs.cost = el;
                                                }}
                                                className="table-responsive flex-grow-1"
                                                style={getTableViewportStyle(isCostCollapsed)}
                                                onScroll={() => this.SyncDetailTableScroll("cost")}
                                            >
                                                <table className="table table-sm table-hover mb-0" style={{ minWidth: "100%", width: "max-content" }}>
                                                    <thead>
                                                        <tr>
                                                            <td className="text-nowrap text-end" style={collapseCostCellStyle(96)}>
                                                                Fee Rate (%)
                                                            </td>
                                                            <td className="text-nowrap text-end" style={collapseCostCellStyle(112)}>
                                                                Fee Amount
                                                            </td>
                                                            <td className="text-nowrap text-end" style={collapseCostCellStyle(112)}>
                                                                Cost VAT
                                                            </td>
                                                            <td className="text-nowrap text-end" style={keepVisibleCostCellStyle(122, 126)}>
                                                                Cost Total
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paginatedDetailTransactions.map((tx, idx) => (
                                                            <tr key={`cost-row-${idx}`} style={syncedTableRowStyle}>
                                                                <td className="text-end text-12" style={collapseCostCellStyle(96)}>{toFixed(tx.cost_gateway_fee_rate, 2)}</td>
                                                                <td className="text-end text-12" style={collapseCostCellStyle(112)}>
                                                                    {toFixed(tx.cost_gateway_fee, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={collapseCostCellStyle(112)}>
                                                                    {toFixed(tx.cost_gateway_vat, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={keepVisibleCostCellStyle(122, 126)}>
                                                                    {toFixed(tx.cost_gateway_total, 2)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {!filteredDetailTransactions.length && (
                                                            <tr style={syncedTableRowStyle}>
                                                                <td colSpan={isCostCollapsed ? 1 : 4} className="text-center text-secondary py-3">
                                                                    {detail_status_filter ? "No cost data for selected status" : "No cost data"}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="rounded-3 border p-2 d-flex flex-column" style={revenuePanelStyle}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 px-1">
                                                <div>
                                                    <div className="fw-bold">Revenue</div>
                                                    <div className="text-12 text-secondary">{isRevenueCollapsed ? "Compact view: key revenue totals" : "Full view: revenue breakdown"}</div>
                                                </div>
                                                <button
                                                    className="btn btn-sm"
                                                    style={getToggleButtonStyle(isRevenueCollapsed, panelTone.revenue)}
                                                    onClick={() => this.setState({ collapse_revenue_fields: !isRevenueCollapsed })}
                                                >
                                                    {isRevenueCollapsed ? "Show All Fields" : "Hide Extra Fields"}
                                                </button>
                                            </div>
                                            <div
                                                ref={(el) => {
                                                    this.detailTableRefs.revenue = el;
                                                }}
                                                className="table-responsive flex-grow-1"
                                                style={getTableViewportStyle(isRevenueCollapsed)}
                                                onScroll={() => this.SyncDetailTableScroll("revenue")}
                                            >
                                                <table className="table table-sm table-hover mb-0" style={{ minWidth: "100%", width: "max-content" }}>
                                                    <thead>
                                                        <tr>
                                                            <td className="text-nowrap text-end" style={collapseRevenueCellStyle(96)}>
                                                                Fee Rate (%)
                                                            </td>
                                                            <td className="text-nowrap text-end" style={collapseRevenueCellStyle(112)}>
                                                                Fee Amount
                                                            </td>
                                                            <td className="text-nowrap text-end" style={collapseRevenueCellStyle(112)}>
                                                                Revenue VAT
                                                            </td>
                                                            <td className="text-nowrap text-end" style={keepVisibleRevenueCellStyle(118, 122)}>
                                                                Revenue Total
                                                            </td>
                                                            <td className="text-nowrap text-end" style={keepVisibleRevenueCellStyle(112, 122)}>
                                                                Gross Profit
                                                            </td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {paginatedDetailTransactions.map((tx, idx) => (
                                                            <tr key={`revenue-row-${idx}`} style={syncedTableRowStyle}>
                                                                <td className="text-end text-12" style={collapseRevenueCellStyle(96)}>{toFixed(tx.revenue_fee_rate, 2)}</td>
                                                                <td className="text-end text-12" style={collapseRevenueCellStyle(112)}>
                                                                    {toFixed(tx.revenue_fee_amount, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={collapseRevenueCellStyle(112)}>
                                                                    {toFixed(tx.revenue_vat, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={keepVisibleRevenueCellStyle(118, 122)}>
                                                                    {toFixed(tx.revenue_total, 2)}
                                                                </td>
                                                                <td className="text-end text-12" style={keepVisibleRevenueCellStyle(112, 122)}>
                                                                    {toFixed(tx.revenue_gross_profit, 2)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        {!filteredDetailTransactions.length && (
                                                            <tr style={syncedTableRowStyle}>
                                                                <td colSpan={isRevenueCollapsed ? 1 : 5} className="text-center text-secondary py-3">
                                                                    {detail_status_filter ? "No revenue data for selected status" : "No revenue data"}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!!filteredDetailTransactions.length && (
                                    <div className="d-flex justify-content-end">
                                        <Pagination
                                            className="mb-2"
                                            count={detailPageCount}
                                            page={detail_page}
                                            showFirstButton
                                            showLastButton
                                            onChange={(_, page) => this.LoadDetail(detail_item, page, false)}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
  }
}
